import React, { useState } from 'react';
import { Mail, Settings, Inbox as InboxIcon } from 'lucide-react';
import EmailAccounts from './EmailAccounts';
import Inbox from './Inbox';

const Email = () => {
  const [activeTab, setActiveTab] = useState('inbox');

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="flex items-center space-x-1 p-2">
          <button
            onClick={() => setActiveTab('inbox')}
            className={`flex items-center px-4 py-2 rounded-lg ${
              activeTab === 'inbox'
                ? 'bg-blue-100 text-blue-700'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <InboxIcon className="h-4 w-4 mr-2" />
            Inbox
          </button>
          <button
            onClick={() => setActiveTab('accounts')}
            className={`flex items-center px-4 py-2 rounded-lg ${
              activeTab === 'accounts'
                ? 'bg-blue-100 text-blue-700'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <Settings className="h-4 w-4 mr-2" />
            Accounts
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-hidden">
        {activeTab === 'inbox' && <Inbox />}
        {activeTab === 'accounts' && <EmailAccounts />}
      </div>
    </div>
  );
};

export default Email;
